/** Allineato a elitefitnessweb/src/constants/appStores.ts */
export const ELITE_APP_DEEPLINK_ORIGIN = 'elitefitness://elitefitness.it';
export const ELITE_IOS_APP_STORE = 'https://apps.apple.com/it/app/id6670614281';
export const ELITE_ANDROID_PLAY_STORE =
    'https://play.google.com/store/apps/details?id=it.utopialabs.elitefitness';

const AUTO_REDIRECT_DELAY_MS = 1500;
const APP_OPEN_DETECT_MS = 1600;

export function getStoreUrlForUserAgent() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(ua)) return ELITE_ANDROID_PLAY_STORE;
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
        return ELITE_IOS_APP_STORE;
    }
    return null;
}

/** Es. /app/redeem-gift → elitefitness://elitefitness.it/redeem-gift */
export function buildEliteDeeplink(pathname, search) {
    const afterApp = pathname.replace(/^\/app\/?/, '/') || '/';
    const path = afterApp === '/' ? '' : afterApp;
    return `${ELITE_APP_DEEPLINK_ORIGIN}${path}${search || ''}`;
}

/**
 * Tenta l'apertura via custom scheme; se la pagina resta attiva, reindirizza allo store (mobile).
 * @returns {number|undefined} timeout id per clearTimeout
 */
export function tryOpenAppThenStore(pathname, search) {
    const storeUrl = getStoreUrlForUserAgent();
    if (!storeUrl) {
        return undefined;
    }
    const deeplink = buildEliteDeeplink(pathname, search);
    const now = Date.now();
    window.location.href = deeplink;
    return window.setTimeout(() => {
        if (Date.now() - now < APP_OPEN_DETECT_MS) {
            window.location.href = storeUrl;
        }
    }, AUTO_REDIRECT_DELAY_MS);
}

export { AUTO_REDIRECT_DELAY_MS, APP_OPEN_DETECT_MS };
